import { useEffect } from "react";
import { useCallbackRef } from "./lifecycle";

export function useGlobalEventListener<K extends keyof WindowEventMap>(
  eventName: K,
  listener: (ev: WindowEventMap[K]) => any,
  options?: boolean | AddEventListenerOptions
) {
  const callbackRef = useCallbackRef(listener);

  useEffect(() => {
    window.addEventListener(eventName, callbackRef, options);
    return () => {
      window.removeEventListener(eventName, callbackRef);
    };
  }, [eventName, callbackRef, options]);

  return () => window.removeEventListener(eventName, callbackRef);
}
